import { render, staticRenderFns } from "./Map.vue?vue&type=template&id=235f36f3&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/admin/Docker/apps2/privacy/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('235f36f3')) {
      api.createRecord('235f36f3', component.options)
    } else {
      api.reload('235f36f3', component.options)
    }
    module.hot.accept("./Map.vue?vue&type=template&id=235f36f3&", function () {
      api.rerender('235f36f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Map.vue"
export default component.exports